import { Helmet } from "react-helmet";

function HomePage() {
  return (
    <>
      <Helmet>
        <title>
          Paculba Flower Shop | Fresh Blooms & Bouquets in Iligan City
        </title>
        <meta
          name="description"
          content="Paculba Flower Shop in Iligan City offers premium flower arrangements and same-day delivery for all occasions."
        />

        <meta property="og:title" content="Paculba Flower Shop Iligan City" />
        <meta
          property="og:description"
          content="Explore stunning flower collections. Same-day delivery in Iligan City and nearby areas."
        />
        <meta
          property="og:url"
          content="https://store.paculbaflowershop.com/"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://localflowershop.sgp1.digitaloceanspaces.com/product/1737790848241-WHITE%20SQUARE.zip%20-%2085.JPG"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Paculba Flower Shop Iligan City" />
        <meta
          name="twitter:description"
          content="Order premium flowers with same-day delivery in Iligan City."
        />
        <meta
          name="twitter:image"
          content="https://localflowershop.sgp1.digitaloceanspaces.com/product/1737790848241-WHITE%20SQUARE.zip%20-%2085.JPG"
        />
      </Helmet>
    </>
  );
}

export default HomePage;
